import { defineStore } from 'pinia';
import { useSessionStorage } from '@vueuse/core';
import { type ChatBotMessage } from '@/features/Eli/types';

export const useVirtualAssistantStore = defineStore('virtualAssistant', {
	state: () => {
		return {
			messages: useSessionStorage(
				'scoro_gpt_messages',
				[] as ChatBotMessage[]
			),
			chatSessionId: useSessionStorage('chat_session_id', ''),
			shouldAskForFeedback: useSessionStorage('chat_ask_feedback', false),
			hasGivenFeedback: useSessionStorage('chat_got_feedback', false),
		};
	},
});
